import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '@src/app/services/login/login.service';
import { PermissionsService } from '@src/app/services/permissions/permissions.service';
import { getPermissions, PermissionName } from '@src/app/model/userdata';
import { filter } from 'rxjs/operators';
import { Subject, takeUntil } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  standalone: false,
})
export class LandingComponent implements OnDestroy {
  private _componentDestroyed$: Subject<void> = new Subject();

  constructor(
    private _router: Router,
    private _loginService: LoginService,
    private _permissionsService: PermissionsService,
    private _translateService: TranslateService
  ) {
    if (this._loginService.isLoggedIn && this._loginService.isMfaAuthenticated) {
      this._loginService.setCurrentUser();
      this._loginService.getCurrentUser$()
        .pipe(takeUntil(this._componentDestroyed$), filter(u => !!u))
        .subscribe((u) => {
          if (this._permissionsService.isPermitted(
            getPermissions(u.roles), 'access_modules', PermissionName.Read)
          ) {
            this._router.navigateByUrl('/blueprints');
          } else if (
            this._permissionsService.isPermitted(
              getPermissions(u.roles), 'access_retailers', PermissionName.Read)) {
            this._router.navigateByUrl('/retailer-settings');
          } else if (
            this._permissionsService.isPermitted(
              getPermissions(u.roles), 'access_retailer_data', PermissionName.Read)) {
            this._router.navigateByUrl('/retailer-data');
          } else {
            this._loginService.logout$().subscribe(() => {
              const text = this._translateService.instant('user.noPermissions');
              alert(text);
              this._router.navigateByUrl('/login');
            });
          }
        });
    } else {
      this._router.navigateByUrl('/login');
    }
  }

  public ngOnDestroy(): void {
    this._componentDestroyed$.next();
  }
}
